import { render, staticRenderFns } from "./PopupLogSubmit.vue?vue&type=template&id=3ff2ea4b&scoped=true&"
import script from "./PopupLogSubmit.vue?vue&type=script&lang=js&"
export * from "./PopupLogSubmit.vue?vue&type=script&lang=js&"
import style0 from "./PopupLogSubmit.vue?vue&type=style&index=0&id=3ff2ea4b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff2ea4b",
  null
  
)

export default component.exports